import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import StaffLayout from './staff/StaffLayout';
import Machine from './Machine'; // Customer-facing
import SuccessPage from './SuccessPage'; // Customer-facing
import StaffPrivateRoute from './staff/StaffPrivateRoute';
import StaffLoginPage from './staff/StaffLoginPage';
import CustomerLoginPage from './auth/CustomerLoginPage';
import CustomerProtectedRoute from './auth/CustomerProtectedRoute';
import { StaffAuthProvider } from './staff/StaffAuthContext';
import { CustomerAuthProvider } from './auth/CustomerAuthContext';
import TermsAndConditions from './pages/legal/TermsAndConditions';
import PrivacyPolicy from './pages/legal/PrivacyPolicy';
import RefundPolicy from './pages/legal/RefundPolicy';
import AboutUs from './pages/legal/AboutUs';
import ContactUs from './pages/legal/ContactUs';


function App() {
  return (
    <StaffAuthProvider>
      <CustomerAuthProvider>
        <Router>
          <Routes>
            {/* Login Pages */}
            <Route path="/staff-login" element={<StaffLoginPage />} />
            <Route path="/customer-login" element={<CustomerLoginPage />} />

            {/* Protected Staff Area */}
            <Route
              path="/staff/*"
              element={
                <StaffPrivateRoute>
                  <StaffLayout />
                </StaffPrivateRoute>
              }
            />

            {/* Private machine requires customer login */}
            <Route
              path="/private-machine"
              element={
                <CustomerProtectedRoute>
                  <Machine />
                </CustomerProtectedRoute>
              }
            />

            {/* Public machine access */}
            <Route path="/machine" element={<Machine />} />
            <Route path="/payment-success" element={<SuccessPage />} />

            {/* Fallback routes */}
            <Route path="/" element={<Navigate to="/machine" />} />
            <Route path="*" element={<Navigate to="/" />} />
            <Route path="/terms" element={<TermsAndConditions />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/refund" element={<RefundPolicy />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/contact" element={<ContactUs />} />
          </Routes>
        </Router>
      </CustomerAuthProvider>
    </StaffAuthProvider>
  );
}

export default App;


// import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
// import StaffLayout from './staff/StaffLayout';
// import Dashboard from './staff/Dashboard';
// import Machine from './Machine'; // customer-facing
// import SuccessPage from './SuccessPage'; // customer-facing
// import StaffPrivateRoute from './staff/StaffPrivateRoute';
// import StaffLoginPage from './staff/StaffLoginPage';
// import CustomerProtectedRoute from "./auth/CustomerProtectedRoute";
// // import CustomerLoginPage from './auth/CustomerLoginPage';

// function App() {
//   return (
//     <Router>
//       <Routes>
//         {/* Login Pages */}
//         <Route path="/staff-login" element={<StaffLoginPage />} />
//         <Route path="/customer-login" element={<CustomerLoginPage />} />

//         {/* Protected Staff Area */}
//         <Route
//           path="/staff/*"
//           element={
//             <StaffPrivateRoute>
//               <StaffLayout />
//             </StaffPrivateRoute>
//           }
//         />

//         {/* Optional: Protect private machine access */}
//         <Route
//           path="/private-machine"
//           element={
//             <CustomerProtectedRoute>
//               <Machine />
//             </CustomerProtectedRoute>
//           }
//         />

//         {/* Public Customer-Facing */}
//         <Route path="/machine" element={<Machine />} />
//         <Route path="/payment-success" element={<SuccessPage />} />

//         {/* Fallback: redirect unknown route to /machine or login */}
//         <Route path="/" element={<Navigate to="/machine" />} />
//         <Route path="*" element={<Navigate to="/" />} />
//       </Routes>
//     </Router>
//   );
// }

// export default App;




